module.exports = __webpack_public_path__ + "img/pepper.be5030ca.webp";